// extracted by mini-css-extract-plugin
export default {"issueFound":"GiOnZPaWLmhElSPERQxT","passing":"GhPxBW6wDE08gy4eXW6Y","needConfiguration":"Kx8SosZIoWUttl67KjjU"};